import { useNetwork } from "wagmi";
import { getDaoContract, getDaoRewardETHContract } from "./contractHelper";
import { DAO_DEFAULT_CHAIN, DAO_REWARD, DAO_SUPPOTED_CHAIN } from "./constant";
import { useEffect, useState } from "react";
import { MulticallContractWeb3 } from "./useContracts";




export const useDaoEthState = (updater) => {
    const { chain } = useNetwork();
    const [stats, setStats] = useState({
        getTotalSupply: [],
        getWeightPercentage: [],
        nftAddress : []
    });

    let chainId = chain && chain.id && DAO_SUPPOTED_CHAIN.includes(chain.id) ? chain.id : DAO_DEFAULT_CHAIN

    const daoContract = getDaoRewardETHContract(chainId, DAO_REWARD[chainId].RPC_URL);
    const daoBstContract  = getDaoContract();

    useEffect(() => {
        const fetch = async () => {
            try {

                const data = await MulticallContractWeb3(
                    [
                        daoContract.methods.getTotalSupply(), //0
                        daoContract.methods.getWeightPercentage() //1

                    ] , DAO_REWARD[chainId].RPC_URL , DAO_REWARD[chainId].MULTICALL_ADDRESS
                );

                const nftAddress = await MulticallContractWeb3([
                    daoBstContract.methods.DAONFT(0)
                ]);
           

                setStats({
                    getTotalSupply: data[0],
                    getWeightPercentage: data[1],
                    nftAddress
                })
            }
            catch (err) {
                console.log(err.message);
            }
        }


        fetch();

        // eslint-disable-next-line
    }, [updater, chain]);

    return stats;
}